import React, { useEffect, useState } from "react";
import auth_logo from "../../../assets/auth_logo.png";
import PersonalInfo from "./registrationModule/PersonalInfo";
import AdditionalInfo from "./registrationModule/AdditionalInfo";
import { Link } from "react-router-dom";
import { logicalicon_blue } from "../../../assets";

const Signup = () => {
  const [registrationStepper, setRegistrationStepper] = useState(
    "personalInfo"
  );
  const [image, setImage] = useState("");
  const [registrationData, setRegistrationData] = useState({});
  const [loading, setLoading] = useState(false);

  const registrationStepperHandler = (currentStepper, data, image) => {
    const { completeMobile, ...restData } = data;
    setRegistrationStepper(currentStepper);
    setRegistrationData(restData);
    if (image) {
      setImage(image);
    }
  };

  useEffect(() => {
    const unloadCallback = (event) => {
      event.preventDefault();
      event.returnValue = "";
      return "";
    };

    window.addEventListener("beforeunload", unloadCallback);
    return () => window.removeEventListener("beforeunload", unloadCallback);
  }, []);

  return (
    <>
      <div className="auth profile">
        <div className="custom_container">
          <div className="row">
            <div className="col-md-12">
              <div className="login_logo">
                <Link to={"/"}>
                  <img src={logicalicon_blue} />
                </Link>
              </div>
            </div>
          </div>
          {registrationStepper === "personalInfo" && (
            <PersonalInfo
              registrationData={registrationData}
              registrationStepperHandler={registrationStepperHandler}
              setImage={setImage}
              image={image}
            />
          )}
          {registrationStepper === "additionalInfo" && (
            <AdditionalInfo
              registrationData={registrationData}
              loading={loading}
              setLoading={setLoading}
              image={image}
              registrationStepperHandler={registrationStepperHandler}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default Signup;
